import request from '@/utils/requests'
/**
 * 填写积分
 * @returns 
 */
// export const flowSavePoint = (data) => {
//   return request({
//       url: '/flow/save_point',
//       method: 'post',
//       data
//   })
// }
export const flowSavePoint = (data) => {
  return request({
      url: 'https://stake-api.metaflow.club/app-api/flow/save_point',
      method: 'post',
      data
  })
}

/**
 * 查询积分
 * @returns 
 */
// export const getPoint = (wallet_address) => {
//   return request({
//       url: `/flow/get_point/${wallet_address}`,
//       method: 'post',
//   })
// }
export const getPoint = (wallet_address) => {
  return request({
      url: `https://stake-api.metaflow.club/app-api/flow/get_point/${wallet_address}`,
      method: 'post',
  })
}